import React, {Component} from 'react';
import OrgMiniView from './OrgMiniView'
import DipMiniView from './DipMiniView'
import ModalConfirm from '../ModalConfirm'
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'

class DipartimentiTableRow extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let d = this.props.item
        let o = this.props.item.idOrganizzazione

        let btnEdit = null;
        let btnDelete = null;
        if (this.props.readOnly === false){
            btnEdit = (<a  className="ui pointer blue icon button" onClick={() => {this.props.onModificaDipartimento(d)}}>
                        <i
                            className="edit icon"

                        ></i>
                    </a>);
            btnDelete = (
                    <ModalConfirm
                        msg={"Stai per cancellare il dipartimento: " + d.nomeCompleto}
                        onClickOk={(ev) => (this.props.onDeleteDipartimento(ev, d))}
                    >
                        <a className="ui red icon button"><i className="trash icon"/></a>
                    </ModalConfirm>
            );
        }

        return (
            <tr>
                <td className="">
                    <div className="content">
                        {d.nomeCompleto}
                        <DipMiniView item={d} />
                    </div>
                    <div className="content">
                        Creato il {d.creatoIl ?  <b><LocalDate data={d.creatoIl } /> <LocalTime data={d.creatoIl } /></b> : <b>?</b>} da <b>{d.creatoDa ? d.creatoDa.username : '?'}</b>&nbsp;
                        Modificato il {d.modificatoIl ?  <b><LocalDate data={d.modificatoIl } /> <LocalTime data={d.modificatoIl } /></b> : <b>?</b>} da <b>{d.modificatoDa ? d.modificatoDa.username : '?'}</b>
                    </div>
                </td>
                <td className="collapsing">
                    <div className="content">
                        {o.nomeCompleto}
                        <OrgMiniView item={o} />
                    </div>
                    <div className="content">
                        Creato il {o.creatoIl ?  <b><LocalDate data={o.creatoIl } /> <LocalTime data={o.creatoIl } /></b> : <b>?</b>} da <b>{o.creatoDa ? o.creatoDa.username : '?'}</b>&nbsp;
                        Modificato il {o.modificatoIl ?  <b><LocalDate data={o.modificatoIl } /> <LocalTime data={o.modificatoIl } /></b> : <b>?</b>} da <b>{o.modificatoDa ? o.modificatoDa.username : '?'}</b>
                    </div>
                </td>
                <td className="collapsing no-print">
                    {btnEdit}
                    {btnDelete}
                </td>
            </tr>)
    }
}

export default DipartimentiTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/DipartimentiTableRow.js
 **/